import * as api from '../api/smartLists';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const namespace = 'BI/SMART_LISTS';

export const FETCH_SMART_LIST_MODULES = createRequestTypes(
  `${namespace}/FETCH_MODULES`,
);

export const FETCH_SMART_LIST_GROUPS = createRequestTypes(
  `${namespace}/FETCH_GROUPS`,
);

export const INSERT_SMART_LIST = createRequestTypes(
  `${namespace}/INSERT_SMART_LIST`,
);

export const FETCH_SMART_LIST = createRequestTypes(
  `${namespace}/FETCH_SMART_LIST`,
);

export const UPDATE_SMART_LIST = createRequestTypes(`${namespace}/UPDATE`);

export const UPDATE_SMART_LIST_TAGS = createRequestTypes(
  `${namespace}/UPDATE_TAGS`,
);

export const FETCH_ALL_APPRAISAL_USERS = createRequestTypes(
  `${namespace}/FETCH_ALL_APPRAISAL_USERS`,
);

export const FETCH_ALL_APPRAISAL_ROLES = createRequestTypes(
  `${namespace}/FETCH_ALL_APPRAISAL_ROLES`,
);

export const FETCH_USER_ACCESS = createRequestTypes(
  `${namespace}/FETCH_USER_ACCESS`,
);

export const INSERT_USER_ACCESS = createRequestTypes(
  `${namespace}/INSERT_USER_ACCESS`,
);

export const DELETE_USER_ACCESS = createRequestTypes(
  `${namespace}/DELETE_USER_ACCESS`,
);

export const FETCH_ROLE_ACCESS = createRequestTypes(
  `${namespace}/FETCH_ROLE_ACCESS`,
);

export const INSERT_ROLE_ACCESS = createRequestTypes(
  `${namespace}/INSERT_ROLE_ACCESS`,
);

export const DELETE_ROLE_ACCESS = createRequestTypes(
  `${namespace}/DELETE_ROLE_ACCESS`,
);

export const INSERT_PARAMETER = createRequestTypes(
  `${namespace}/INSERT_PARAMETER`,
);

export const UPDATE_PARAMETER = createRequestTypes(
  `${namespace}/UPDATE_PARAMETER`,
);

export const DELETE_PARAMETER = createRequestTypes(
  `${namespace}/DELETE_PARAMETER`,
);

export const FETCH_ALL_PARAMETERS = createRequestTypes(
  `${namespace}/FETCH_ALL_PARAMETERS`,
);

export const CLEAR_PARAMETERS = `${namespace}/CLEAR_PARAMETERS`;
export const clearParameters = () => ({
  type: CLEAR_PARAMETERS,
});

export const EXECUTE_QUERY_PREVIEW = createRequestTypes(
  `${namespace}/EXECUTE_QUERY_PREVIEW`,
);

export const EXECUTE_QUERY_DOWNLOAD = createRequestTypes(
  `${namespace}/EXECUTE_QUERY_DOWNLOAD`,
);

export const EXECUTE_QUERY_PREVIEW_UNIQUE = createRequestTypes(
  `${namespace}/EXECUTE_QUERY_PREVIEW_UNIQUE`,
);

export const fetchModules = makeApiActionCreatorV3(
  api.fetchSmartListModules,
  FETCH_SMART_LIST_MODULES[START],
  FETCH_SMART_LIST_MODULES[SUCCESS],
  FETCH_SMART_LIST_MODULES[ERROR],
);

export const fetchGroups = makeApiActionCreatorV3(
  api.fetchSmartListGroups,
  FETCH_SMART_LIST_GROUPS[START],
  FETCH_SMART_LIST_GROUPS[SUCCESS],
  FETCH_SMART_LIST_GROUPS[ERROR],
);

export const fetchSmartList = makeApiActionCreatorV3(
  api.fetchSmartList,
  FETCH_SMART_LIST[START],
  FETCH_SMART_LIST[SUCCESS],
  FETCH_SMART_LIST[ERROR],
);

export const insertSmartList = makeApiActionCreatorV3(
  api.insertSmartList,
  INSERT_SMART_LIST[START],
  INSERT_SMART_LIST[SUCCESS],
  INSERT_SMART_LIST[ERROR],
);

export const updateSmartList = makeApiActionCreatorV3(
  api.updateSmartList,
  UPDATE_SMART_LIST[START],
  UPDATE_SMART_LIST[SUCCESS],
  UPDATE_SMART_LIST[ERROR],
);

export const updateSmartListTags = makeApiActionCreatorV3(
  api.updateSmartListTags,
  UPDATE_SMART_LIST_TAGS[START],
  UPDATE_SMART_LIST_TAGS[SUCCESS],
  UPDATE_SMART_LIST_TAGS[ERROR],
);

export const fetchAllAppraisalUsers = makeApiActionCreatorV3(
  api.fetchAllAppraisalUsers,
  FETCH_ALL_APPRAISAL_USERS[START],
  FETCH_ALL_APPRAISAL_USERS[SUCCESS],
  FETCH_ALL_APPRAISAL_USERS[ERROR],
);

export const fetchAllAppraisalRoles = makeApiActionCreatorV3(
  api.fetchAllAppraisalRoles,
  FETCH_ALL_APPRAISAL_ROLES[START],
  FETCH_ALL_APPRAISAL_ROLES[SUCCESS],
  FETCH_ALL_APPRAISAL_ROLES[ERROR],
);

export const fetchUserAccess = makeApiActionCreatorV3(
  api.fetchUserAccess,
  FETCH_USER_ACCESS[START],
  FETCH_USER_ACCESS[SUCCESS],
  FETCH_USER_ACCESS[ERROR],
);

export const insertUserAccess = makeApiActionCreatorV3(
  api.insertUserAccess,
  INSERT_USER_ACCESS[START],
  INSERT_USER_ACCESS[SUCCESS],
  INSERT_USER_ACCESS[ERROR],
);

export const deleteUserAccess = makeApiActionCreatorV3(
  api.deleteUserAccess,
  DELETE_USER_ACCESS[START],
  DELETE_USER_ACCESS[SUCCESS],
  DELETE_USER_ACCESS[ERROR],
);

export const fetchRoleAccess = makeApiActionCreatorV3(
  api.fetchRoleAccess,
  FETCH_ROLE_ACCESS[START],
  FETCH_ROLE_ACCESS[SUCCESS],
  FETCH_ROLE_ACCESS[ERROR],
);

export const insertRoleAccess = makeApiActionCreatorV3(
  api.insertRoleAccess,
  INSERT_ROLE_ACCESS[START],
  INSERT_ROLE_ACCESS[SUCCESS],
  INSERT_ROLE_ACCESS[ERROR],
);

export const deleteRoleAccess = makeApiActionCreatorV3(
  api.deleteRoleAccess,
  DELETE_ROLE_ACCESS[START],
  DELETE_ROLE_ACCESS[SUCCESS],
  DELETE_ROLE_ACCESS[ERROR],
);

export const insertParameter = makeApiActionCreatorV3(
  api.insertParameter,
  INSERT_PARAMETER[START],
  INSERT_PARAMETER[SUCCESS],
  INSERT_PARAMETER[ERROR],
);

export const updateParameter = makeApiActionCreatorV3(
  api.updateParameter,
  UPDATE_PARAMETER[START],
  UPDATE_PARAMETER[SUCCESS],
  UPDATE_PARAMETER[ERROR],
);

export const deleteParameter = makeApiActionCreatorV3(
  api.deleteParameter,
  DELETE_PARAMETER[START],
  DELETE_PARAMETER[SUCCESS],
  DELETE_PARAMETER[ERROR],
);

export const fetchAllParameters = makeApiActionCreatorV3(
  api.fetchAllParameters,
  FETCH_ALL_PARAMETERS[START],
  FETCH_ALL_PARAMETERS[SUCCESS],
  FETCH_ALL_PARAMETERS[ERROR],
);

export const executeQueryPreview = makeApiActionCreatorV3(
  api.executeQueryPreview,
  EXECUTE_QUERY_PREVIEW[START],
  EXECUTE_QUERY_PREVIEW[SUCCESS],
  EXECUTE_QUERY_PREVIEW[ERROR],
);

export const executeQueryDownload = makeApiActionCreatorV3(
  api.executeQueryDownload,
  EXECUTE_QUERY_DOWNLOAD[START],
  EXECUTE_QUERY_DOWNLOAD[SUCCESS],
  EXECUTE_QUERY_DOWNLOAD[ERROR],
);

export const executeQueryPreviewUnique = makeApiActionCreatorV3(
  api.executeQueryPreview,
  EXECUTE_QUERY_PREVIEW_UNIQUE[START],
  EXECUTE_QUERY_PREVIEW_UNIQUE[SUCCESS],
  EXECUTE_QUERY_PREVIEW_UNIQUE[ERROR],
);

export const FETCH_SMART_LIST_TYPES = createRequestTypes(
  `BI/SMART_LISTS/FETCH_SMART_LIST_TYPES`,
);

export const fetchSmartListTypes = makeApiActionCreatorV3(
  api.fetchSmartListTypes,
  FETCH_SMART_LIST_TYPES[START],
  FETCH_SMART_LIST_TYPES[SUCCESS],
  FETCH_SMART_LIST_TYPES[ERROR],
);

export const FETCH_SMART_LIST_SEARCH_CONFIG = createRequestTypes(
  `${namespace}/FETCH_SMART_LIST_SEARCH_CONFIG`,
);

export const fetchSmartListSearchConfig = makeApiActionCreatorV3(
  api.fetchSmartListSearchConfig,
  FETCH_SMART_LIST_SEARCH_CONFIG[START],
  FETCH_SMART_LIST_SEARCH_CONFIG[SUCCESS],
  FETCH_SMART_LIST_SEARCH_CONFIG[ERROR],
);

export const FETCH_SMART_LIST_SEARCH_CONFIG_RESULTS = createRequestTypes(
  `${namespace}/FETCH_SMART_LIST_SEARCH_CONFIG_RESULTS`,
);

export const fetchSmartListSearchConfigResults = makeApiActionCreatorV3(
  api.fetchSmartListSearchConfigResults,
  FETCH_SMART_LIST_SEARCH_CONFIG_RESULTS[START],
  FETCH_SMART_LIST_SEARCH_CONFIG_RESULTS[SUCCESS],
  FETCH_SMART_LIST_SEARCH_CONFIG_RESULTS[ERROR],
);

export const SEARCH_SMART_LIST = createRequestTypes(
  `${namespace}/SEARCH_SMART_LIST`,
);

export const searchSmartList = makeApiActionCreatorV3(
  api.searchSmartList,
  SEARCH_SMART_LIST[START],
  SEARCH_SMART_LIST[SUCCESS],
  SEARCH_SMART_LIST[ERROR],
);

export const SEARCH_VALIDATION_SMART_LIST = createRequestTypes(
  `${namespace}/SEARCH_VALIDATION_SMART_LIST`,
);

export const searchValidationSmartList = makeApiActionCreatorV3(
  api.searchValidationSmartList,
  SEARCH_VALIDATION_SMART_LIST[START],
  SEARCH_VALIDATION_SMART_LIST[SUCCESS],
  SEARCH_VALIDATION_SMART_LIST[ERROR],
);

export const DELETE_SMART_LIST = createRequestTypes(
  `${namespace}/DELETE_SMART_LIST`,
);

export const deleteSmartList = makeApiActionCreatorV3(
  api.deleteSmartList,
  DELETE_SMART_LIST[START],
  DELETE_SMART_LIST[SUCCESS],
  DELETE_SMART_LIST[ERROR],
);

export const RESET_EXECUTE_DATA = `${namespace}/RESET_EXECUTE_DATA`;
export const resetExecuteData = () => ({
  type: RESET_EXECUTE_DATA,
});

export const CHANGE_PAGE = `${namespace}/CHANGE_PAGE`;
export const changePage = page => ({
  type: CHANGE_PAGE,
  payload: page,
});

export const CHANGE_ROWS_PER_PAGE = `${namespace}/CHANGE_ROWS_PER_PAGE`;
export const changeRowsPerPage = rowsPerPage => ({
  type: CHANGE_ROWS_PER_PAGE,
  payload: rowsPerPage,
});

export const CHANGE_SORT_MODEL = `${namespace}/CHANGE_SORT_MODEL`;
export const changeSortModel = model => ({
  type: CHANGE_SORT_MODEL,
  payload: model,
});

export const INSERT_USER_FAVORITE = createRequestTypes(
  `${namespace}/INSERT_USER_FAVORITE`,
);

export const insertUserFavorite = makeApiActionCreatorV3(
  api.insertUserFavorite,
  INSERT_USER_FAVORITE[START],
  INSERT_USER_FAVORITE[SUCCESS],
  INSERT_USER_FAVORITE[ERROR],
);

export const DELETE_USER_FAVORITE = createRequestTypes(
  `${namespace}/DELETE_USER_FAVORITE`,
);

export const deleteUserFavorite = makeApiActionCreatorV3(
  api.deleteUserFavorite,
  DELETE_USER_FAVORITE[START],
  DELETE_USER_FAVORITE[SUCCESS],
  DELETE_USER_FAVORITE[ERROR],
);

export const FETCH_MOST_CURRENT_PROPERTY = createRequestTypes(
  'APPRAISAL/FETCH_MOST_CURRENT_PROPERTY',
);

export const fetchMostCurrentProperty = makeApiActionCreatorV3(
  api.fetchMostCurrentProperty,
  FETCH_MOST_CURRENT_PROPERTY[START],
  FETCH_MOST_CURRENT_PROPERTY[SUCCESS],
  FETCH_MOST_CURRENT_PROPERTY[ERROR],
);

export const EXECUTE_SMART_LIST_DOWNLOAD_HISTORY = createRequestTypes(
  'APPRAISAL/EXECUTE_SMART_LIST_DOWNLOAD_HISTORY',
);

export const executeSmartListDownloadHistory = makeApiActionCreatorV3(
  api.executeSmartListDownloadHistory,
  EXECUTE_SMART_LIST_DOWNLOAD_HISTORY[START],
  EXECUTE_SMART_LIST_DOWNLOAD_HISTORY[SUCCESS],
  EXECUTE_SMART_LIST_DOWNLOAD_HISTORY[ERROR],
);

export const FETCH_SMART_LIST_DOWNLOAD_HISTORY = createRequestTypes(
  'APPRAISAL/FETCH_SMART_LIST_DOWNLOAD_HISTORY',
);

export const fetchSmartListDownloadHistory = makeApiActionCreatorV3(
  api.fetchSmartListDownloadHistory,
  FETCH_SMART_LIST_DOWNLOAD_HISTORY[START],
  FETCH_SMART_LIST_DOWNLOAD_HISTORY[SUCCESS],
  FETCH_SMART_LIST_DOWNLOAD_HISTORY[ERROR],
);

export const DOWNLOAD_SMART_LIST_DOWNLOAD_HISTORY_FILE = createRequestTypes(
  'APPRAISAL/DOWNLOAD_SMART_LIST_DOWNLOAD_HISTORY_FILE',
);

export const downloadSmartListDownloadHistoryFile = makeApiActionCreatorV3(
  api.downloadSmartListDownloadHistoryFile,
  DOWNLOAD_SMART_LIST_DOWNLOAD_HISTORY_FILE[START],
  DOWNLOAD_SMART_LIST_DOWNLOAD_HISTORY_FILE[SUCCESS],
  DOWNLOAD_SMART_LIST_DOWNLOAD_HISTORY_FILE[ERROR],
);


